import {
  Select,
  MenuItem,
  OutlinedInput,
  BaseSelectProps,
  FormControl,
  InputLabel,
} from "@mui/material";
import { memo } from "react";

export interface VDSelectProps extends BaseSelectProps {
  data?: any[];
}

export const CSelect = memo((props: VDSelectProps) => {
  return (
    <FormControl fullWidth={props.fullWidth} required={props.required}>
      {props.label && <InputLabel id="label-select">{props.label}</InputLabel>}
      <Select
        labelId="label-select"
        {...props}
        input={
          <OutlinedInput fullWidth={props.fullWidth} label={props.label} />
        }
      >
        {props.data &&
          props.data.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        {props.children && props.children}
      </Select>
    </FormControl>
  );
});
